import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AccessCheckService } from './access-check.service';
import { map } from 'rxjs/operators';

export function roleGuard(
  redirectUrl: string[],
  allowedRoles: string[],
): CanActivateFn {
  return () => {
    const router: Router = inject(Router);
    const accessCheckService: AccessCheckService = inject(AccessCheckService);

    return accessCheckService.hasRequiredRole(allowedRoles).pipe(
      map((hasRole: boolean) => {
        if (hasRole) {
          return true;
        }
        return router.createUrlTree(redirectUrl);
      }),
    );
  };
}
